import { observer } from 'mobx-react-lite';

import { TaggedPeopleCard } from './tagged-people-card';
import { useTaggedPeopleCards } from './use-tagged-people-cards';

/** The card above the composer for the people that the draft tags, when they are not on Littlebird or not connected */
export const TaggedPeopleCards = observer(
  ({ draftId }: { draftId: string }) => {
    const { card, status, run, dismiss } = useTaggedPeopleCards(draftId);
    if (!card) return null;
    return (
      <TaggedPeopleCard
        kind={card.kind}
        names={card.people.map(({ person }) => person.name)}
        status={status}
        onAction={() => void run()}
        onDismiss={dismiss}
      />
    );
  }
);
